import { fontRitualMonoMedium, fontRitualMono, fontRitualVariable } from "@/assets";
import { injectGlobal } from "@/domains/emotion";

export const MEM_FONT_FAMILY_ATTRIBUTE_STRING = `Ritual, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`;

export const _injectGlobalProviders = () => {
  injectGlobal({
    "@font-face": {
      fontFamily: "Ritual Mono",
      fontStyle: `normal`,
      fontWeight: `100 900`,
      fontDisplay: `swap`,
      src: `url("${fontRitualMono}") format("opentype")`,
    },
  });

  injectGlobal({
    "@font-face": {
      fontFamily: "Ritual Mono Medium",
      fontStyle: `normal`,
      fontWeight: `100 900`,
      fontDisplay: `swap`,
      src: `url("${fontRitualMonoMedium}") format("opentype")`,
    },
  });

  // Variable font declaration for Ritual-VF.ttf with backtick substitution
  injectGlobal({
    "@font-face": {
      fontFamily: "Ritual",
      fontStyle: `normal`,
      fontWeight: `100 900`, // Variable font weight range
      fontDisplay: `swap`, // Better loading behavior
      src: `url("${fontRitualVariable}") format("truetype")`,
      unicodeRange: `U+0000-005F, U+0061-10FFFF`, // Exclude backtick U+0060
    },
  });

  // Fallback font for backtick character only
  injectGlobal({
    "@font-face": {
      fontFamily: "Ritual",
      fontStyle: `normal`,
      fontWeight: `100 900`,
      fontDisplay: `swap`,
      src: `local("-apple-system"), local("BlinkMacSystemFont"), local("Segoe UI"), local("Roboto"), local("Helvetica"), local("Arial"), local("sans-serif")`,
      unicodeRange: `U+0060`, // Only for backtick character
    },
  });

  injectGlobal({
    "*:focus-visible": {
      // Avoid blue outline on modals and other elements.
      outline: "none",
    },

    html: {
      textRendering: "optimizeLegibility",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
    },

    body: {
      margin: 0,
    },

    input: {
      outline: "none",
      border: "none",
    },

    button: {
      outline: "none",
      border: "none",
      cursor: "pointer",
      userSelect: "none",
      color: "unset",
      backgroundColor: "unset",
    },

    submit: {
      border: "none",
    },

    a: {
      textDecoration: "none",
    },

    "*": {
      boxSizing: "border-box",
      fontFamily: MEM_FONT_FAMILY_ATTRIBUTE_STRING,
    },
  });
};
